import type { Tool } from '@/features/traceability/type/Tool';
import type { AnalyticsDataset } from '../types';
import { sanitizeReference } from './reference';
import { aggregatePieces } from './trace';

/**
 * Builds a leaderboard dataset from an array of tools.
 * @param tools The array of tools to process.
 * @returns The constructed leaderboard dataset.
 */
export const buildLeaderboardFromTools = (tools: Tool[]): AnalyticsDataset => {
  const map = new Map<string, number>();

  tools.forEach((tool) => {
    const reference = sanitizeReference(tool.reference);
    if (!reference) return;
    const pieces = aggregatePieces(Array.isArray(tool.traces) ? tool.traces : []);
    map.set(reference, (map.get(reference) ?? 0) + pieces);
  });

  const entries = Array.from(map.entries()).sort((a, b) => b[1] - a[1]);

  return {
    labels: entries.map(([label]) => label),
    values: entries.map(([, value]) => value),
  };
};
